import { useState, useEffect } from 'react'

export interface GuestSession {
  tripId: string
  guestName: string
  guestEmail?: string
  inviteCode: string
  guestSessionId?: string
  guestAccessToken?: string
  isGuest: boolean
}

const GUEST_SESSION_KEY = 'sitrep_guest_session'

export function useGuestSession() {
  const [guestSession, setGuestSession] = useState<GuestSession | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Load guest session from localStorage on mount
    const stored = localStorage.getItem(GUEST_SESSION_KEY)
    if (stored) {
      try {
        const session = JSON.parse(stored)
        setGuestSession(session)
      } catch (error) {
        localStorage.removeItem(GUEST_SESSION_KEY)
      }
    }
    setIsLoading(false)
  }, [])

  const setGuestSessionData = (session: GuestSession) => {
    setGuestSession(session)
    localStorage.setItem(GUEST_SESSION_KEY, JSON.stringify(session))
  }

  const clearGuestSession = () => {
    setGuestSession(null)
    localStorage.removeItem(GUEST_SESSION_KEY)
  }

  const isGuestAccess = (tripId: string) => {
    return guestSession?.tripId === tripId && guestSession?.isGuest === true
  }

  return {
    guestSession,
    isLoading,
    setGuestSessionData,
    clearGuestSession,
    isGuestAccess
  }
}
